module.exports = __webpack_public_path__ + "b67018b3da97ef6f15a6ef5dce132f0b.woff";